/*
  Lyana Editorial Reveal -- shared, minimal scroll-reveal utility.

  Used by sections/lyana-campaign-banner.liquid and sections/lyana-world.liquid
  so the same mechanism isn't duplicated in two files. Generic on purpose:
  any element carrying [data-lyana-reveal] is observed once; when roughly a
  quarter of it enters the viewport, this adds a single class
  ("lyana-reveal-active") and stops observing. All staggering (heading,
  then paragraph, then CTA) is done with CSS transition-delay on the
  section's own child selectors -- this file never times anything itself.

  Respects prefers-reduced-motion (skips straight to the revealed state)
  and degrades gracefully if IntersectionObserver isn't available (shows
  content immediately rather than risking it staying hidden).
*/
(function () {
  if (window.__lyanaEditorialRevealInit) return;
  window.__lyanaEditorialRevealInit = true;

  function revealNow(el) {
    el.classList.add('lyana-reveal-active');
  }

  function init() {
    var targets = document.querySelectorAll('[data-lyana-reveal]');
    if (!targets.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(revealNow);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealNow(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.25 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
